module.exports = " <p class=scrub-input _v-297d8c2c=\"\"> <input type=range v-bind:value=position v-on:input=changed _v-297d8c2c=\"\"> </p> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-297d8c2c!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/scrubber.vue
// module id = 318
// module chunks = 0